import styled from 'styled-components'

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,
  TwitterIcon,
} from 'react-share'

export interface IProps {
  title?: string
  slug?: string
  url: string
  image?: string
}

const ShareButtons = ({ url, image }: IProps) => {
  return (
    <Container>
      <FacebookShareButton url={url}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <TwitterShareButton url={url}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <LinkedinShareButton url={url}>
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>
      <EmailShareButton url={url}>
        <EmailIcon size={32} round />
      </EmailShareButton>
      <PinterestShareButton url={url} media={image ?? ''}>
        <PinterestIcon size={32} round />
      </PinterestShareButton>
    </Container>
  )
}

export default ShareButtons

const Container = styled.div`
  position: sticky;
  top: 50%;
  /* left: 1rem; */
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-self: start;
  justify-content: start;
  gap: 1rem;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
